const C = {
    brand:  '#F777B0',
    brand2: '#D94F92',
    ink:    '#1A1614',
    ink2:   '#3D3632',
    ink3:   '#8A8079',
    paper:  '#F9F9F9',
    paper2: '#F2F2F2',
    hair:   '#EBEBEB',
    hair2:  '#D8D8D8',
    serif:  '"Instrument Serif", "Songti SC", serif',
    sans:   '"Inter", "Noto Sans SC", -apple-system, sans-serif',
    mono:   'ui-monospace, monospace',
};

export default C;
